import { RootState } from "@/app/stores"
import { deleteUser, recoverUser } from "@/shared/api/users"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchUserDeleteOrRecover = createAsyncThunk<
    void,
    void,
    { state: RootState; rejectValue: ErrorType }
>('userDeleteRestore/fetchUserDeleteOrRecover', async (_, thunkAPI) => {
    const { currentUserId, mode } = thunkAPI.getState().userDeleteRestore
    if (!currentUserId) return

    try {
        if (mode === 'delete') {
            await deleteUser(currentUserId)
        } else {
            await recoverUser(currentUserId)
        }
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        } as ErrorType)
    }
})
